import React, {useState, useEffect, useMemo} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputText from '../FormFields/InputText';
import SelectInfinite from '../FormFields/SelectInfinite';
import TextArea from '../FormFields/Textarea';
import InputDate from '../FormFields/inputDate/InputDate';
import {useForm, FormProvider, useFormContext} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import {getLanguage, t} from 'react-switch-lang';
import * as yup from 'yup';
import ModalHistory from '../../app/Measures/components/ShowHistoryModal';
import ModalVerify from '../../app/Measures/components/VerifyModal';
import {
    updateMeasure, getMeasureFile,
} from '../../services/measuresService/measuresApi';
import {getAllRiskRelatedUsers} from '../../services/usersService';
import {appModules, defaultMinValueZero, validDouble} from '../../utils/const';
import {format} from 'date-fns';
import Toast from '../toast/Toast';
import Trash from '../../app/Measures/img/Trash.svg';
import SelectList from '../../components/FormFields/select/SelectList';
import DownloadOutlined from '@ant-design/icons/lib/icons/DownloadOutlined';
import allowedFileTypes from '../../utils/allowedFileTypes';
import PreventTransitionPrompt from '../preventTransitionprompt/PreventTransition';
import {
    formatNumberInput,
    parseFormattedNumber,
    maxDecimalNumber, formatNumberForDisplay,
    onDecimalNumberInputChange, testIsGreaterThanMin,
    testValidNumber, handlePasteAndValidate
} from "../../utils/helpers";
import FileUploadSection from "../FileUploadSection/FileUploadSection";
import {getRiskFile} from "../../services/potentialRiskService";
import Prompt from "../prompt/prompt";
import {acceptRiskByDepartmentStakeholder} from "../../services/IncurredEvent/incurredEventApi";

function MeasuresFromShow({
                              data,
                              toggleOpen,
                              open,
                              userData,
                              userResponsibleRisk,
                              riskId,
                              estimatedGrossLost,
                              allowEdit,
                              riskStatusId,
                              disabled,
                              setDisabled,
                              setScheme
                          }) {

    // const {handleSubmit, watch,reset, trigger,setValue,setError,clearErrors,formState: { isDirty }} = methods;
    const {handleSubmit, watch,
        reset, trigger,setValue,setError,clearErrors,formState: { isDirty}} = useFormContext()


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDateModalOpen, setIsDateModalOpen] = useState(false);
    const [isModalVerifyOpen, setIsModalVerifyOpen] = useState(false);
    const [id, setId] = useState(data.id);
    const [files, setFiles] = useState([]);
    const [deleteFiles, setDeleteFiles] = useState([]);
    const [defaultFiles, setDefaultFiles] = useState(data?.files);
    const [disableBtn, setDisableBtn] = useState(false);

    const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const fetchUsers = async (pageNumber = page, size = pageSize) => {
    try {
      const { data } = await getAllRiskRelatedUsers(pageNumber, size);

      const content = Array.isArray(data?.content) ? data.content : [];

      const usersMap = content.map((item) => ({
        value: item.id,
        label: `${item.firstName} ${item.lastName}`,
      }));

      setUsers(usersMap);
    } catch (e) {
      console.error(e);
    }
  };


  useEffect(() => {
    fetchUsers(page, pageSize);
  }, [page, pageSize]);
    const lang = getLanguage();

    const optionsTask = [{value: 'NOTSTARTED', label: `${t('mitigation-measures.notStarted')}`}, {
        value: 'INPROGRESS', label: `${t('mitigation-measures.inProgress')}`
    }, {value: 'REALIZED', label: `${t('mitigation-measures.realized')}`},];

    const toggleShowModal = (e) => {
        e && e.preventDefault();
        setIsModalOpen(!isModalOpen);
    };

    const toggleDateHistoryModal = (e) => {
        e && e.preventDefault();
        setIsDateModalOpen(!isDateModalOpen);
    }

    const setEdit = (e) => {
        e && e.preventDefault();
        setDisabled(false);
    };

    const toggleVerifyModal = (e) => {
        e && e.preventDefault();
        setIsModalVerifyOpen(!isModalVerifyOpen);
    };

    const submitForm = async (submitedData) => {
        setDisableBtn(true);
        const files = document.getElementById('upload').files;
        const dateFormated = format(new Date(submitedData.realizationDate), 'yyyy-MM-dd') + 'T' + format(new Date(submitedData.realizationDate), 'hh:mm:ss');

        const payload = {
            id: id,
            mitigationMeasures: submitedData.mitigationMeasures,
            costEstimationId: submitedData.cost.value,
            departmentInChargeId: submitedData.department.value,
            grossLoss: parseFormattedNumber(watch('grossLoss')),
            lossChargedInsurance: parseFormattedNumber(submitedData.lossChargedInsurance),
            lossChargedOther: parseFormattedNumber(submitedData.lossChargedOther),
            levelOfMeasureRealization: submitedData.levelOfMeasureRealization.value,
            hdRequestId: submitedData.hdRequestId,
            mitigationPercentage: parseFloat(submitedData.mitigationPercentage),
            netLoss: parseFormattedNumber(watch('netLoss')),
            riskAnalysis: submitedData.riskAnalysis,
            realizationDate: dateFormated,
            notStartedReason: submitedData.notStartedReason,
            userResponsibleId: submitedData.userResponsibleId.value,
            riskId: riskId,
            userCreatedId: userData.id,
            appliedMeasureResult: {name: submitedData.resultOfApplied},
            deleteFiles: deleteFiles,
            additionalMitigationMeasures: submitedData.additionalMitigationMeasures,
            measureStatus: data.measureStatus,
        };
        try {
            const response = await updateMeasure(payload, files);
            if (response.status === 200) {
                await Toast.fire({
                    title: t('message.updateSuccess3', {entity: t('common.measure')}), icon: 'success',
                });
            }
            // toggleOpen(!open);
            setDisabled(true);
            await window.location.reload();
            setDisableBtn(false);
        } catch (err) {
            if (err.response.status === 400) {
                await Toast.fire({
                    title: t('message.errorApi'), icon: 'error',
                });
            }
            if (err.response.code === 'file-format') {
                await Toast.fire({
                    title: t('message.fileFormatNotAllowed'), icon: 'error',
                });
            }
            toggleOpen(!open);
            setDisableBtn(false);
        }
    };



    useEffect(() => {
        if (disabled === false) {
            setDisabled(true);
        }
    }, [open]);




    const wathcLevelOfRealization = watch('levelOfMeasureRealization');

    const handleCancel = (e) => {
        e.preventDefault();
        if(isDirty) {
            return new Promise((resolve, reject) => {
                Prompt.fire({
                    title: t('title.measureEdit'),
                    text: t('question.warningMeasureEdit'),
                    confirmButtonText: t('common.confirm').toUpperCase(),
                    cancelButtonText: t('common.cancel').toUpperCase(),
                    preConfirm: async () => {
                        toggleOpen(!open);
                        reset();
                        setDisabled(true);
                    },
                });
            });
        } else {
            toggleOpen(!open)
        }
    };


    useEffect(() => {
        if (wathcLevelOfRealization?.value) {
            if (wathcLevelOfRealization?.value === 'NOTSTARTED') {
                setScheme(yup.object().shape({
                    realizationDate: yup
                        .string()
                        .nullable()
                        .trim()
                        .required(t('message.fieldRequired')),
                    riskAnalysis: yup
                        .string()
                        .trim()
                        .max(2000, t('message.max', {max: 2000})),
                    levelOfMeasureRealization: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    cost: yup.object().nullable().required(t('message.fieldRequired')),
                    department: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    notStartedReason: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(1000, t('message.max', {max: 1000})),
                    grossLoss: yup
                        .string()
                        .trim()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedInsurance: yup
                        .string()
                        .trim()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedOther: yup
                        .string()
                        .trim()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    netLoss: yup
                        .string()
                        .trim()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    mitigationMeasures: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(2000, t('message.max', {max: 2000})),
                    hdRequestId: yup.string().trim(),
                    mitigationPercentage: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers'))
                        .test('max-100', t('message.maxValue', { max: 100 }), value => {
                            const num = parseFloat(value?.replace(',', '.') ?? '');
                            return isNaN(num) || num <= 100;
                        }),
                    additionalMitigationMeasures: yup
                        .string()
                        .trim()
                        .max(2000, t('message.max', {max: 2000})),
                    resultOfApplied: yup
                        .string()
                        .trim()
                        .max(1000, t('message.max', {max: 1000})),
                }));
            } else if (wathcLevelOfRealization?.value === 'INPROGRESS') {
                setScheme(yup.object().shape({
                    realizationDate: yup
                        .string()
                        .nullable()
                        .trim()
                        .required(t('message.fieldRequired')),
                    riskAnalysis: yup
                        .string()
                        .trim()
                        .max(2000, t('message.max', {max: 2000})),
                    levelOfMeasureRealization: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    cost: yup.object().nullable().required(t('message.fieldRequired')),
                    department: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    resultOfApplied: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(1000, t('message.max', {max: 1000})),
                    grossLoss: yup
                        .string()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedInsurance: yup
                        .string()
                        .trim()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedOther: yup
                        .string()
                        .trim()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    netLoss: yup
                        .string()
                        .trim()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    mitigationMeasures: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(2000, t('message.max', {max: 2000})),
                    hdRequestId: yup.string().trim(),
                    mitigationPercentage: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers'))
                        .test('max-100', t('message.maxValue', { max: 100 }), value => {
                            const num = parseFloat(value?.replace(',', '.') ?? '');
                            return isNaN(num) || num <= 100;
                        }),
                    additionalMitigationMeasures: yup
                        .string()
                        .trim()
                        .max(2000, t('message.max', {max: 2000})),
                    notStartedReason: yup
                        .string()
                        .trim()
                        .max(1000, t('message.max', {max: 1000})),
                }));
            } else {
                setScheme(yup.object().shape({
                    realizationDate: yup
                        .string()
                        .nullable()
                        .trim()
                        .required(t('message.fieldRequired')),
                    riskAnalysis: yup
                        .string()
                        .trim()
                        .max(2000, t('message.max', {max: 2000})),
                    levelOfMeasureRealization: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    cost: yup.object().nullable().required(t('message.fieldRequired')),
                    department: yup
                        .object()
                        .nullable()
                        .required(t('message.fieldRequired')),
                    resultOfApplied: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(1000, t('message.max', {max: 1000})),
                    grossLoss: yup
                        .string()
                        .trim()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedInsurance: yup
                        .string()
                        .trim()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    lossChargedOther: yup
                        .string()
                        .trim()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    netLoss: yup
                        .string()
                        .trim()
                      .when([], {
                        is: () => !window.location.pathname.includes('potential-risk'),
                        then: (schema) =>
                          schema
                            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                              return testIsGreaterThanMin(value, defaultMinValueZero);
                            })
                            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                              return testValidNumber(value, true);
                            })
                            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                              return maxDecimalNumber(value);
                            }),
                        otherwise: yup.string().trim(),
                      })
                        .typeError(t('message.onlyDecimalNumbers')),
                    mitigationMeasures: yup
                        .string()
                        .trim()
                        .required(t('message.fieldRequired'))
                        .max(2000, t('message.max', {max: 2000})),
                    hdRequestId: yup.string().trim(),
                    mitigationPercentage: yup
                        .string()
                        .trim()
                        .matches(validDouble, t('message.onlyDecimalNumbers'))
                        .typeError(t('message.onlyDecimalNumbers'))
                        .test('max-100', t('message.maxValue', { max: 100 }), value => {
                            const num = parseFloat(value?.replace(',', '.') ?? '');
                            return isNaN(num) || num <= 100;
                        }),
                    additionalMitigationMeasures: yup
                        .string()
                        .trim()
                        .max(2000, t('message.max', {max: 2000})),
                    notStartedReason: yup
                        .string()
                        .trim()
                        .max(1000, t('message.max', {max: 1000})),
                }));
            }
        }
    }, [wathcLevelOfRealization]);


    const clearFetchedFile = (id) => {
        let children = defaultFiles.filter((file) => file.id !== id);
        let deleteFilesIds = [];
        deleteFilesIds.push(id);
        setDefaultFiles([...children]);
        setDeleteFiles(deleteFilesIds);
    };




    const onChangeMitigationPercentage = (e) => {
        let result = '';
        let valueNoText = e.target.value.replace(/[^0-9.]/, '');
        let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
        if (valueDouble !== undefined && valueDouble !== null) {
            result = valueDouble[1];
        }
        setValue('mitigationPercentage', result);
    };


    const watchLossChargedInsurance = watch('lossChargedInsurance');
    const watchLossChargedOther = watch('lossChargedOther');
    const watchEstimatedGrossLost = watch('grossLoss');

    useEffect(() => {
        if (watchLossChargedInsurance && watchLossChargedOther) {
            let no = parseFormattedNumber(watchEstimatedGrossLost) - parseFormattedNumber(watchLossChargedInsurance) - parseFormattedNumber(watchLossChargedOther);
            if(no < 0) {
                setError("netLoss", { type: 'is-greater-than-min', message: t('message.minValue', {min: defaultMinValueZero})})
            }else {
                clearErrors('netLoss')
            }
            if(no) {
                setValue(
                    'netLoss',
                    formatNumberInput(
                        formatNumberForDisplay(no).includes(',')
                            ? formatNumberForDisplay(no)
                            : formatNumberForDisplay(no) + ',00'
                        , 2
                    )
                );
            }else {
                setValue('netLoss',0);
            }
        }
    }, [watchLossChargedInsurance, watchLossChargedOther,watchEstimatedGrossLost]);


    const grossLossFormatted = useMemo(() => {
        if(data.grossLoss !== null && data.grossLoss !== undefined) {
            return  formatNumberInput(formatNumberForDisplay(data.grossLoss));
        }else {
            return estimatedGrossLost !== null && estimatedGrossLost !== 'no-data' ? formatNumberInput(formatNumberForDisplay(estimatedGrossLost)) : '';
        }
    }, [data.grossLoss,estimatedGrossLost]);


    const lossChargedInsuranceFormatted = useMemo(() => {
        return data.lossChargedInsurance !== null ? formatNumberInput(formatNumberForDisplay(data.lossChargedInsurance)) : '';
    }, [data.lossChargedInsurance]);

    const lossChargedOtherFormatted = useMemo(() => {
        return data.lossChargedOther !== null ? formatNumberInput(formatNumberForDisplay(data.lossChargedOther)) : '';
    }, [data.lossChargedOther]);

    const netLossFormatted = useMemo(() => {
        return data.netLoss ? formatNumberInput(formatNumberForDisplay(data.netLoss)) : '';
    }, [data.netLoss]);

    return (<>
        <PreventTransitionPrompt when={!disabled}/>
        <form onSubmit={handleSubmit(submitForm)}>
            <Row className="mb-5 main-form">
                <Col xs={6} md={6} lg={3}>
                    <label className="label-measures">
                        {t('mitigation-measures.person')}
                    </label>
                    <SelectList
                        name="userResponsibleId"
                        className="select"
                        options={users}
                        defaultValue={{
                            value: data.userResponsibleId,
                            label: data.userResponsibleFirstName + ' ' + data.userResponsibleLastName,
                        }}
                        placeholder={t('placeholder.userResponsibleId')}
                        isClearable={false}
                        isDisabled={true}
                    />
                    <label className="label-measures">
                        {t('mitigation-measures.analysis')}
                    </label>
                  <span className="optional register">{t('common.optional')}</span>
                  <TextArea
                        name="riskAnalysis"
                        className={`form-control height text-area `}
                        placeholder={t('placeholder.riskAnalysis')}
                        disabled={disabled}
                        defaultValue={data.riskAnalysis}
                    />
                </Col>
                <Col xs={6} md={6} lg={3}>
                    <label className="label-measures">
                        {t('mitigation-measures.proposed')}
                    </label>
                    <TextArea
                        name="mitigationMeasures"
                        className="form-control text-area"
                        placeholder={t('placeholder.mitigationMeasures')}
                        disabled={disabled}
                        defaultValue={data.mitigationMeasures}
                    />
                    <label className="label-measures">
                        {t('mitigation-measures.charge-of-implementing')}
                    </label>
                    <SelectInfinite
                      api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                      name="department"
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        defaultValue={{
                            value: data.departmentInChargeId, label: `${lang === 'mne' ? data.departmentInChargeName : data.departmentInChargeNameEn}`
                        }}
                        isDisabled={disabled}
                        placeholder={t('placeholder.departments')}
                    />
                    <label className="label-measures">
                        {t('mitigation-measures.cost-estimation')}
                    </label>
                    <SelectInfinite
                        api="/cost-estimations"
                        name="cost"
                        labelKey="cost"
                        className="select"
                        defaultValue={{
                            value: data.costEstimationId, label: data.costEstimationCost,
                        }}
                        isDisabled={disabled}
                        placeholder={t('placeholder.costEstimation')}
                        queryKeys={'cost.contains'}
                    />
                    <label className="label-measures">
                        {t('mitigation-measures.date')}
                    </label>
                    <span
                        className="link-history"
                        onClick={(e) => toggleDateHistoryModal(e)}
                    >
                                      {t('mitigation-measures.dateHistory')}
                            </span>
                    <InputDate
                        name="realizationDate"
                        placeholderText={t('placeholder.pickDate')}
                        defaultValue={new Date(data.realizationDate)}
                        // selected={new Date(data.realizationDate)}
                        disabled={disabled}
                        // isClearable={disabled ? false : true}
                        isClearable={false}
                    />
                </Col>
                <Col xs={6} md={6} lg={3}>
                    <label className="label-measures">
                        {t('mitigation-measures.result')}
                    </label>
                    <span
                        className="link-history"
                        onClick={(e) => toggleShowModal(e)}
                    >
                {t('mitigation-measures.history')}
              </span>
                    <TextArea
                        name="resultOfApplied"
                        className={`form-control height text-area `}
                        placeholder={t('placeholder.result')}
                        defaultValue={data.appliedMeasureResult?.name}
                        disabled={disabled}
                    />
                    <label className='label-measures'>
                        {t('mitigation-measures.IDHDRequest')}
                    </label>
                    <span className="optional register">{t('common.optional')}</span>
                    <InputText
                        type='string'
                        name='hdRequestId'
                        className='form-control input-field'
                        placeholder={t('placeholder.IDHDRequest')}
                        id='hdRequestId'
                        defaultValue={data.hdRequestId}
                        disabled={disabled}
                    />
                    <label className="label-measures">
                        {t('mitigation-measures.mitigation-percentage')}
                    </label>
                    <span className="optional register">{t('common.optional')}</span>
                    <InputText
                        type="number"
                        name="mitigationPercentage"
                        className="form-control input-field"
                        placeholder={t('placeholder.mitigationPercentage')}
                        defaultValue={data.mitigationPercentage}
                        disabled={disabled}
                        step=".01"
                        min="0"
                        onChange={onChangeMitigationPercentage}
                    />
                    <label className="label-measures">
                        {t('mitigation-measures.status')}
                    </label>
                    <SelectList
                        name="levelOfMeasureRealization"
                        className="select"
                        options={optionsTask}
                        defaultValue={{
                            value: data.levelOfMeasureRealization,
                            label: data.levelOfMeasureRealization === 'NOTSTARTED' ? t('mitigation-measures.notStarted') : data.levelOfMeasureRealization === 'INPROGRESS' ? t('mitigation-measures.inProgress') : t('mitigation-measures.realized'),
                        }}
                        placeholder={t('placeholder.levelOfMeasureRealization')}
                        isClearable={false}
                        isDisabled={disabled}
                    />
                </Col>
                <Col xs={6} md={6} lg={3}>
                    <label className="label-measures">
                        {t('mitigation-measures.reason')}
                    </label>
                    <TextArea
                        name="notStartedReason"
                        className="form-control text-area"
                        placeholder={t('placeholder.notStartedReason')}
                        disabled={disabled}
                        defaultValue={data.notStartedReason}
                    />
                </Col>
              {!window.location.pathname.includes('potential-risk') &&
              <Col xs={6} md={6} lg={3}>
                    <label className="label-measures">
                        {t('mitigation-measures.loss-gross')}
                    </label>
                    <span className="optional register">{t('common.optional')}</span>
                    <InputText
                        type="text"
                        name="grossLoss"
                        className="form-control input-field"
                        placeholder={t('placeholder.lossGross')}
                        defaultValue={grossLossFormatted}
                        disabled={disabled}
                        onChange={(e) => onDecimalNumberInputChange(e,setValue,"grossLoss")}
                        onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'grossLoss')}
                    />
                    <label className="label-measures">
                        {t('mitigation-measures.loss-collected')}
                    </label>
                    <span className="optional register">{t('common.optional')}</span>
                    <InputText
                        type="text"
                        name="lossChargedInsurance"
                        className="form-control input-field"
                        placeholder={t('placeholder.lossCollected')}
                        defaultValue={lossChargedInsuranceFormatted}
                        disabled={disabled}
                        onChange={(e) => onDecimalNumberInputChange(e,setValue,"lossChargedInsurance")}
                        onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'lossChargedInsurance')}
                    />
                    <label className="label-measures">
                        {t('mitigation-measures.loss-collected-other')}
                    </label>
                    <span className="optional register">{t('common.optional')}</span>
                    <InputText
                        type="text"
                        name="lossChargedOther"
                        className="form-control input-field"
                        defaultValue={lossChargedOtherFormatted}
                        disabled={disabled}
                        placeholder={t('placeholder.lossCollectedOther')}
                        onChange={(e) => onDecimalNumberInputChange(e,setValue,"lossChargedOther")}
                        onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'lossChargedOther')}
                    />
                    <label className="label-measures">
                        {t('mitigation-measures.loss-net')}
                    </label>
                    <span className="optional register">{t('common.optional')}</span>
                    <InputText
                        type="text"
                        name="netLoss"
                        className="form-control input-field"
                        placeholder={t('placeholder.lossNet')}
                        defaultValue={netLossFormatted}
                        disabled={true}
                        onChange={(e) => onDecimalNumberInputChange(e,setValue,"netLoss")}
                    />
                </Col>}
                <Col xs={6} md={6} lg={3}>
                    <label className="label-measures">
                        {t('mitigation-measures.proposalAdditional')}
                    </label>
                    <span className="optional register">{t('common.optional')}</span>
                    <InputText
                        type="text"
                        name="additionalMitigationMeasures"
                        className="form-control input-field"
                        placeholder={t('placeholder.mitigationMeasuresAdditional')}
                        defaultValue={data.additionalMitigationMeasures}
                        disabled={disabled}
                    />
                    <label className="label-measures">
                        {t('mitigation-measures.upload')}
                    </label>
                    <FileUploadSection
                        disabled={disabled}
                        allowedFileTypes={allowedFileTypes}
                        fetchedFiles={defaultFiles}
                        onDeleteFetchedFile={clearFetchedFile}
                        onNewFilesChange={(newFiles) => setFiles(newFiles)}
                        onFileDownload={getRiskFile}
                    />
                </Col>
            </Row>
            <Row className="mb-3 pt-3 right-btns">
                <Col lg={12} className="btns-float-right">
                    {userResponsibleRisk === userData.id && data.measureStatus !== 'VERIFIED' && (riskStatusId === 2 || riskStatusId === 3)
                        && (<button
                            className="btn btn-primary btn-strong"
                            onClick={(e) => toggleVerifyModal(e)}
                        >
                            {t('buttons.verifyBtn')}
                        </button>)}
                    {allowEdit && disabled && data.measureStatus !== 'CLOSED' && (<button
                        className="btn btn-primary btn-strong ml-2"
                        onClick={(e) => setEdit(e)}
                    >
                        {t('buttons.changeBtn')}
                    </button>)}

                    {disabled === false && (<>
                        <button
                            className="btn btn-cancel btn-strong"
                            type="reset"
                            onClick={handleCancel}
                        >
                            {t('buttons.cancelBtn')}
                        </button>
                        <button
                            className="btn btn-primary btn-strong"
                            disabled={disableBtn || !isDirty}
                        >
                            {t('buttons.saveBtn')}
                        </button>
                    </>)}
                </Col>
            </Row>
        </form>

        <ModalHistory
            data={data.id}
            open={isModalOpen}
            isOpen={(e) => setIsModalOpen(e)}
        />
        <ModalHistory
            data={data.id}
            open={isDateModalOpen}
            isOpen={(e) => setIsDateModalOpen(e)}
            isDateHistory={true}
        />
        <ModalVerify
            open={isModalVerifyOpen}
            id={data.id}
            isOpen={(e) => setIsModalVerifyOpen(e)}
        />
    </>);
}

export default MeasuresFromShow;